<style>
    .k-invalid + .k-form-error.k-invalid-msg {
        display: block !important;
    }
</style>
<template>
    <div>
        <form ref="form" v-kendo-validator="validatorOptions()" @submit.prevent="submitDefault">
            <slot></slot>

            <!--<template v-slot:modal-footer>
              <slot name="actions">
                <div class="row">
                  <b-btn-group class="mr-2">
                    <b-btn block variant="default" @click="close">Cancelar</b-btn>
                  </b-btn-group>
                  <b-btn-group class="mr-2">
                    <b-btn block variant="primary" :disabled="disableSubmit" type="submit">Salvar</b-btn>
                  </b-btn-group>
                </div>
              </slot>
            </template>-->
        </form>
    </div>
</template>
<script>
export default {
  props: {
    model: "",
    submit: Function,
    disableSubmit: { type: Boolean, default: false }
  },
  data () {
    return {
      defaultModel: {},
      test: null
    }
  },
  methods: {
    submitDefault: function (e) {
      e.preventDefault()
      if (this.$api.UI.FormValidate(this)) {
        if (this.submit) { this.submit() }
      }
    },
    validatorOptions: function () {
      return {
        rules: {
          money: function (input) {
            var el = input[0]
            el.setCustomValidity('')
            if (el.getAttribute('required') && el.getAttribute('data-value')) {
              var value = kendo.parseFloat(el.value)
              if (value <= 0) {
                el.setCustomValidity('é obrigatório')
                return false
              }
            }
            return true
          }
        },
        errorTemplate: ''// '<span class="k-form-error k-invalid-msg" data-for="search" id="search-error"><span class="k-icon k-i-warning"> </span>&nbsp;#=message#</span>'
      }
    },
    // Para funcionar a função clear, o nome do model deve ser especificado no componente. Ex.: model="nome"
    clear: function () {
      let th = this
      if (th.model) {
        th.$nextTick(function () {
          var data = th.$api.UTIL.Functions.CopyObject(th.defaultModel)
          Object.keys(data).forEach(k => {
            th.$parent[th.model][k] = data[k]
          })
          th.$parent[th.model] = Object.assign({}, data)
          th.$set(th.$parent, th.model, data)
          th.$refs.form.reset()
        })
      }
    }
  },
  mounted: function () {
    if (this.model) {
      this.$nextTick(function () {
        let th = this
        var unWatch = th.$watch('$store.getters.activeRequests', function (newValue, oldValue) {
          if (newValue == 0) {
            unWatch()
            this.$nextTick(function () {
              this.defaultModel = this.$api.UTIL.Functions.CopyObject(this.$parent[this.model])
            })
          }
        }, { deep: true })
      })
    }
  }
}
</script>
